// extracted by mini-css-extract-plugin
export default {"centered":"_2-RWp","unsubscribe-width":"_2AIM9","unsubscribeWidth":"_2AIM9"};